import {Backdrop, Box, alpha} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const DropTarget = React.forwardRef(
  ({open, isActive, children, sx, ...props}, ref) => {
    return (
      <Backdrop
        ref={ref}
        open={open}
        sx={{
          color: 'common.white',
          zIndex: 'modal',
          '&:before': {
            content: '""',
            border: '2px dashed',
            color: 'common.white',
            outline: 'none',
            position: 'absolute',
            top: theme => theme.spacing(3),
            right: theme => theme.spacing(3),
            bottom: theme => theme.spacing(3),
            left: theme => theme.spacing(3),
          },
          backgroundColor: isActive
            ? alpha('#161822', 0.45)
            : alpha('#161822', 0.65),
          ...sx,
        }}
        {...props}
      >
        <Box
          sx={{
            padding: 0.5,
            textAlign: 'center',
          }}
        >
          {children}
        </Box>
      </Backdrop>
    );
  }
);

DropTarget.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  isActive: PropTypes.bool,
  sx: PropTypes.object,
};

export default DropTarget;
